import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function scrollToFirstError() {
  setTimeout(() => {
    // Select elements that indicate an error:
    // 1. ARIA invalid attributes (standard a11y)
    // 2. Red border classes (custom validation)
    // 3. Red text classes (error messages)
    // We prioritize inputs over messages to focus the user on where to fix the issue.
    const selector = '[aria-invalid="true"], .border-red-500, .text-red-500';
    const errorElement = document.querySelector(selector);
    
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Try to focus if it's an interactive element
      if (errorElement instanceof HTMLElement) {
        const isInteractive = 
          errorElement.tagName === 'INPUT' || 
          errorElement.tagName === 'SELECT' || 
          errorElement.tagName === 'TEXTAREA' || 
          errorElement.getAttribute('role') === 'combobox' ||
          errorElement.getAttribute('tabindex') !== null;

        if (isInteractive) {
            errorElement.focus({ preventScroll: true });
        }
      }
    }
  }, 100);
}